export const config = {
  title: 'Easy Cleaning',
  meta: {
    description: 'Easy Cleaning offers professional house and office cleaning, home organizing, and carpet cleaning services in San Jose, SF.',
    keywords: [
      'Easy Cleaning',
      'House Cleaning',
      'Office Cleaning',
      'Home Organizing',
      'Carpet Cleaning',
      'San Jose Cleaning Services',
    ],
    author: 'Easy Cleaning',
    canonicalUrl: 'https://www.easycleaningworks.com/',
  },
  sections: {
    header: {
      businessName: 'Easy Cleaning',
    },
    sectionB: {
      heroTitle: 'Easy Cleaning',
      heroSubtitle: 'Professional Cleaning Services in San Jose, SF',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '14083039488',
      phoneLabel: '(408) 303-9488',
      heroBackgroundImage: 'https://media.istockphoto.com/id/1443933711/photo/close-up-on-a-cleaner-working-at-a-hospital-and-cleaning-a-handrail.jpg?s=612x612&w=0&k=20&c=WqSTdbeT2Zixzep0PmEoP3fVOSvJERo7tclw5znHhDw=',
      cardData: [
        {
          title: 'House Cleaning',
          description: 'Effortless house cleaning tailored to your needs! Our professional team ensures your home is spotless, fresh, and welcoming.',
        },
        {
          title: 'Office Cleaning',
          description: 'Professional office cleaning services designed to create a clean, productive, and inviting workspace.',
        },
        {
          title: 'Home Organizing',
          description: 'Transform your home with our expert organizing services! We create functional, clutter-free spaces tailored to your lifestyle.',
        },
      ],
      description: 'Since 2019, Easy Cleaning has been committed to delivering high-quality cleaning services for both residential and commercial properties in the Bay Area, California.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription: 'Explore our range of professional cleaning services tailored to meet your needs.',
      cards: [
        {
          title: 'House Cleaning',
          description: 'Effortless house cleaning tailored to your needs! Our professional team ensures your home is spotless, fresh, and welcoming.',
          imageSrc: 'https://www.easycleaningworks.com/images/house-keeping.avif',
          imageAlt: 'House Cleaning',
        },
        {
          title: 'Office Cleaning',
          description: 'Professional office cleaning services designed to create a clean, productive, and inviting workspace.',
          imageSrc: 'https://www.easycleaningworks.com/images/office-cleaning.avif',
          imageAlt: 'Office Cleaning',
        },
        {
          title: 'Home Organizing',
          description: 'Transform your home with our expert organizing services! We create functional, clutter-free spaces tailored to your lifestyle.',
          imageSrc: 'https://www.easycleaningworks.com/images/house-organizing.avif',
          imageAlt: 'Home Organizing',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Carpet Cleaning',
        'Deep Cleaning',
        'Move-In/Move-Out Cleaning',
        'Post-Construction Cleaning',
        'Window Cleaning',
        'Eco-Friendly Cleaning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.easycleaningworks.com/images/clean-house.png',
        alt: 'Easy Cleaning Team',
      },
      aboutText: [
        'Since 2019, Easy Cleaning has been committed to delivering high-quality cleaning services for both residential and commercial properties in the Bay Area, California.',
        'With years of experience, advanced cleaning techniques, and eco-friendly products, we guarantee exceptional results and customer satisfaction.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Easy Cleaning Logo',
      businessName: 'Easy Cleaning',
      contact: {
        phone: '14083039488',
        phoneLabel: '(408) 303-9488',
        email: 'careeasyclean@gmail.com',
        website: 'https://www.easycleaningworks.com/',
        address: 'San Jose, CA 95121, United States',
      },
      socialMedia: {
        facebook: "https://www.facebook.com/people/EasyClean/61573443298658/?mibextid=wwXIfr",
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'San Jose, CA 95121, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.123456789012!2d-121.1234567!3d37.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f123456789012%3A0xabcdef1234567890!2sSan%20Jose%2C%20CA%2095121%2C%20USA!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
